<template>
  <div class="graduate-detail-sign">
    <!--    <img src="../../../assets/img/introduce.png" class="competition-img">-->
    <!--    <img v-if="bannerList.length>0" :src="bannerList[0].image" class="competition-img">-->
    <!--    <a-carousel :after-change="onChange" v-if="bannerList!=null && bannerList.length>0">-->
    <!--      <img-->
    <!--          :src="img.image"-->
    <!--          v-for="(img, index) of bannerList"-->
    <!--          :key="index"-->
    <!--          class="course-img"-->
    <!--      />-->
    <!--    </a-carousel>-->
    <!--    <div v-if="activityInfo!=null" class="activityTitle">{{ activityInfo.title }}</div>-->

    <div style="padding:30px 0 30px 0">
      <div class="sign-content">
        <div class="collect-data">
          <h3>选择参加的赛道类型</h3>
          <div class="plate-info" v-if="check('plateId')">
            <div class="plate-options">
              <label v-for="(item,index) of plateList" :key="index">
<!--                <input type="radio" id="plateId" v-model="form.plateId" name="plateId" :value="item.id"> {{ item.name }}-->
                <!-- 移除重复的id，增加自定义类名 -->
                <input type="radio" class="custom-radio" v-model="form.plateId" name="plateId" :value="item.id">
                <span class="radio-label">{{ item.name }}</span>
              </label>
              <span v-if="error.plateId" class="error">{{ error.plateId }}</span>
            </div>
          </div>
          <h3>参赛门类</h3>
          <div class="plate-info" v-if="check('categoryId')">
            <div class="plate-options">
              <label v-for="(item,index) of categoryList" :key="index">
                <!-- 移除重复的id，增加自定义类名 -->
                <input type="radio" class="custom-radio" v-model="form.categoryId" name="categoryId" :value="item.id">
                <span class="radio-label">{{ item.name }}</span>
              </label>
              <span v-if="error.categoryId" class="error">{{ error.categoryId }}</span>
            </div>
          </div>
          <h3 v-if="check('compete')">选择参赛形式</h3>
          <div class="plate-info" v-if="check('compete')">
            <div class="plate-options">
              <label v-for="(item,index) of competeList" :key="index">
                <!-- 移除重复的id，增加自定义类名 -->
                <input type="radio" class="custom-radio" v-model="form.compete" name="compete" :value="item.id">
                <span class="radio-label">{{ item.name }}</span>
              </label>
              <span v-if="error.compete" class="error">{{ error.compete }}</span>
            </div>
          </div>
          <h3 style="margin-bottom: 8px;">基本信息</h3>
          <form @submit.prevent="onSubmit">
            <div class="person-info">
              <p v-if="check('realName')">
                <label for="realName"><i>*</i>作者姓名</label>
                <input id="realName" ref="realNameInput" type="text" autocomplete="off" v-model="form.realName" placeholder="请填写姓名"/>
                <span v-if="error.realName" class="error">{{ error.realName }}</span>
              </p>
              <p v-if="check('avatar')">
                <label for="avatar"><i>*</i>作者照片</label>
                <Upload v-model="form.avatar" ref="avatarInput" type="image" :num="1" :width="86" :height="86"/>
                <span v-if="error.avatar" class="error"  style="margin-left:80px;margin-bottom: 20px;">{{ error.avatar }}</span>
              </p>
              <p v-if="check('schoolId')">
                <label for="schoolId"><i>*</i>机构选择</label>
                <select id="schoolId" v-model="form.schoolId" ref="schoolIdInput" autocomplete="off" >
                  <option value="" disabled selected hidden ><font color="#999999">请选择机构（学校）</font> </option>
                  <option v-for="school in schoolList" :key="school.id" :value="school.id">{{ school.title }}</option>
                </select>
                <span v-if="error.schoolId" class="error">{{ error.schoolId }}</span>
              </p>
              <p v-if="check('mentor')">
                <label for="mentor"><i>*</i>指导老师</label>
                <input id="mentor" ref="mentorInput" type="text" autocomplete="off" v-model="form.mentor" placeholder="请填写你的指导教师"/>
                <span v-if="error.mentor" class="error">{{ error.mentor }}</span>
              </p>
              <p v-if="check('name')">
                <label for="name"><i>*</i>作品名称</label>
                <input id="name" ref="nameInput" type="text" autocomplete="off" v-model="form.name" placeholder="请填写作品名称"/>
                <span v-if="error.name" class="error">{{ error.name }}</span>
              </p>

              <p v-if="check('material')">
                <label for="material"><i>*</i>作品材料</label>
                <input id="material" ref="materialInput" type="text" autocomplete="off" v-model="form.material" placeholder="请填写作品材料"/>
                <span v-if="error.material" class="error">{{ error.material }}</span>
              </p>
              <p v-if="check('worksSize')">
                <label for="worksSize"><i>*</i>作品尺寸</label>
                <input id="worksSize" ref="worksSizeInput" type="text" autocomplete="off" v-model="form.worksSize" placeholder="请填写作品尺寸，示例：1000CM*200CM（以实物重量或尺寸为主）"/>
                <span v-if="error.worksSize" class="error">{{ error.worksSize }}</span>
              </p>
              <p v-if="check('weight')">
                <label for="weight"><i>*</i>作品重量</label>
                <input id="weight" ref="weightInput" type="text" autocomplete="off" v-model="form.weight" placeholder="请填写作品重量，示例：5Kg（以实物重量或尺寸为主）"/>
                <span v-if="error.weight" class="error">{{ error.weight }}</span>
              </p>
              <p v-if="check('isElectricity')">
                <label for="isElectricity" ><i>*</i>是否用电</label>
                  <a-radio-group v-model="form.isElectricity" name="isElectricity" class="custom-radio-group" >
                    <a-radio v-for="(item, index) in isElectricityList" :key="index" :value="item.id" class="custom-radio">{{ item.name }}</a-radio>
                  </a-radio-group>
                <span v-if="error.isElectricity" class="error">{{ error.isElectricity }}</span>
              </p>

              <p v-if="check('panoramaType')" >
                <label for="panoramaType"><i>*</i>展陈形式</label>
                  <a-radio-group v-model="form.panoramaType" name="panoramaType" autocomplete="off" class="custom-radio-group" >
                    <a-radio v-for="(item, index)  in panoramaTypeList" :key="index"  :value="item.id" class="custom-radio">{{ item.name }}</a-radio>
                  </a-radio-group>
                <span v-if="error.panoramaType" class="error">{{ error.panoramaType }}</span>
              </p>
              <p v-if="check('created')">
                <label for="created"><i>*</i>创作时间</label>
                <a-date-picker suffixIcon=' '  ref="createdInput" style="width: 80%" autocomplete="off" format="YYYY-MM-DD" value-format="YYYY-MM-DD" v-model="form.created" placeholder="请填写创作时间，示例：2025-01-24" />
                <span v-if="error.created" class="error">{{ error.created }}</span>
              </p>

              <p v-if="check('panorama')">
                <label for="panorama"><i>*</i>展陈要求</label>
                <textarea id="panorama" ref="panoramaInput" type="text" autocomplete="off" v-model="form.panorama" placeholder="请填写具体的展示要求" style="height: 70px;"/>
                <span v-if="error.panorama" class="error"  style="margin-top:-35px;">{{ error.panorama }}</span>
              </p>
              <p v-if="check('content')">
                <label for="content"><i>*</i>设计说明</label>
                <textarea id="content" ref="contentInput" v-if="form.categoryId===13" autocomplete="off" v-model="form.content" placeholder="请填写服装类产品设计说明"  style="height: 70px;"></textarea>
                <textarea id="content" ref="contentInput" v-else-if="form.categoryId===14" autocomplete="off" v-model="form.content" placeholder="从灵感来源、文化内涵、设计特色、环保理念、目标用户群体、市场定位与潜在需求出发"  style="height: 70px;"></textarea>
                <textarea id="content" ref="contentInput" v-else-if="form.categoryId===15" autocomplete="off" v-model="form.content" placeholder="从作品的空间构造、尺寸、安装要求及技术实现路径出发"  style="height: 70px;"></textarea>
                <textarea id="content" ref="contentInput" v-else autocomplete="off" v-model="form.content" placeholder="请填写设计说明"  style="height: 70px;"></textarea>
                <span v-if="error.content" class="error" style="margin-top:-35px;">{{ error.content }}</span>
              </p>
              <p v-if="check('image')">
                <label for="image"><i>*</i>作品图片</label>
                <Upload v-model="form.image" type="image" :num="20" :width="86" :height="86" ref="imageInput"/>
                <span v-if="form.categoryId===13">
                  <div class="msg" style="margin-top: 0px;">格式要求：JPG/PNG;分辨率300DPI以上;</div>
                  <div class="msg" style="margin-top: 5px;">设计图要求：每个系列3~5套，男装、女装不限;</div>
                  <div class="msg" style="margin-top: 5px;">首页需包含彩色时装设计效果图和设计主题</div>
                  <div class="msg" style="margin-top: 5px;margin-bottom: 20px">其余页包含每套服装的款式图，主题说明，清晰标注所使用的材质、具体工艺及关键设计细节</div>
                </span>
                <span v-else-if="form.categoryId===14">
                  <div class="msg" style="margin-top: 0px;">格式要求:格式:JPG/PNG;分辨率300DPI以上;</div>
                  <div class="msg" style="margin-top: 5px;">设计图要求：不少于3张作品的创意效果图、款式图或结构图;</div>
                  <div class="msg" style="margin-top: 5px;margin-bottom: 20px">创意效果图需标注所使用的材料以及具体的制作工艺。</div>
                </span>
                <span v-else-if="form.categoryId===15">
                  <div class="msg" style="margin-top: 0px;">格式要求:格式:JPG/PNG;分辨率300DPI以上;</div>
                  <div class="msg" style="margin-top: 5px;">设计图要求：不少于3张作品的效果图，</div>
                  <div class="msg" style="margin-top: 5px;margin-bottom: 20px">效果图需标注所使用的材料以及具体的制作工艺。</div>
                </span>
                <span v-else>
                  <div class="msg" style="margin-top: 0px;">要求：格式：JPG/PNG；分辨率300DPI以上；</div>
                  <div class="msg" style="margin-top: 5px;">不少于3张,最多10张设计效果图、款式图/结构图（如适用）；</div>
                  <div class="msg" style="margin-top: 5px;margin-bottom: 20px">图中清晰标注所使用的材质、具体工艺及关键设计细节。</div>
                </span>
                <span v-if="error.image" class="error" style="margin-top: -10px; margin-left:80px;margin-bottom: 30px;">{{ error.image }}</span>
              </p>
              <p v-if="check('video')">
                <label for="video"><i></i>非必选项</label>
                <!--              <input id="video" ref="videoInput" type="text" autocomplete="off" v-model="form.video" placeholder="请填写作品视频链接"/>-->
                <UploadVideo v-model="form.video" type="video" :num="1" :width="84" :height="84" ref="videoInput"/>
                <span v-if="error.video" class="error"  style="margin-left:80px;margin-bottom: 20px;">{{ error.video }}</span>
              </p>
              <h3 style="margin-bottom: 8px;">联系方式</h3>
              <p v-if="check('email')">
                <label for="email"><i>*</i>收件邮箱</label>
                <input id="email" ref="emailInput" type="email" autocomplete="off" v-model="form.email" placeholder="请填写收件邮箱"/>
                <span v-if="error.email" class="error">{{ error.email }}</span>
              </p>
              <p v-if="check('phone')">
                <label for="mobile"><i>*</i>联系方式</label>
                <input id="mobile" ref="mobileInput" type="text" autocomplete="off"  pattern="^1[3-9]\d{9}$" maxlength="11" v-model="form.mobile" placeholder="请填写联系方式"/>
                <span v-if="error.mobile" class="error">{{ error.mobile }}</span>
              </p>
              <p v-if="check('address')">
                <label for="address"><i>*</i>作品反寄</label>
                <input id="address" ref="addressInput" type="text" autocomplete="off" v-model="form.address" placeholder="请填写作品反寄地址"/>
                <span v-if="error.address" class="error">{{ error.address }}</span>
              </p>
              <div class="agreement" v-if="0">
                <em :class="{ isAgree: isAgree }" @click="handleClcikAgree"></em>
                我已同意并阅读 <span @click="handleClickPrivacy">《赛事承诺书》</span>
              </div>
<!--              <button type="submit" class="submit-button" v-show="!isSubmitting">提交材料</button>-->
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {bannerAreaList} from "@/api/CourseCenter";
import {activityDetail, getActivityPlateList, getActivityCategoryList, getActivitySchoolList, worksSignUp} from "@/api/Vote.js";
import Upload from "@/components/Upload/index"
import UploadVideo from "@/components/UploadVideo/video"
import {mapGetters} from "vuex";

// import ImageUpload from "@/components/Upload/ImageUpload"
export default {
  name: "workCompetitionSignUp",
  components: {
    Upload,
    UploadVideo,
    // ImageUpload
  },
  data() {
    return {
      isSubmitting:false,
      isAgree:false,
      activityId: 0,
      activityInfo: {},
      avatarPreview: "",
      imagePreviews: [],
      bannerList: [],
      plateList: [],
      categoryList: [],
      // competeList:[{id:0,name:"实物参赛"},{id:1,name:"设计稿参赛"}],
      competeList:[{id:2,name:"独立作品"},{id:3,name:"系列作品"}],
      isElectricityList:[{id:0,name:'否'},{id:1,name:'是'}],
      panoramaTypeList:[{id:0,name:'展台'},{id:1,name:'上墙'},{id:2,name:'悬挂'}],
      schoolList: [],
      signConfig: [],
      checkArr: [],
      form: {
        activityId: 0,
        plateId: '',
        categoryId: '',
        schoolId: '',//学校
        compete:2,
        realName: '',//作者姓名
        avatar: '',//作者照片
        sex: 0,//0女1男
        speciality: "",//专业
        education: "",//学历
        mentor: "",//导师姓名
        name: "",//作品名称
        content: "",//作品简介
        material: "",//作品材料
        weight: "",//作品重量
        worksSize: "",//作品尺寸
        created: "",//创作时间
        image: "",
        video: "",//作品视频
        panorama: "",//全景展示链接
        panoramaType:0,
        isElectricity:0,
        mobile: "",//电话
        email: "",//Email
        address: "",
      },
      error: {
        activityId: '',
        plateId: '',
        categoryId: '',
        schoolId: "",//学校
        compete:"",
        realName: "",//作者姓名
        avatar: '',//作者照片
        sex: '',//0女1男
        speciality: "",//专业
        education: "",//学历
        mentor: "",//导师姓名
        name: "",//作品名称
        content: "",//作品简介
        material: "",//作品材料
        weight: "",//作品重量
        worksSize: "",//作品尺寸
        created: "",//创作时间
        image: "",
        video: "",//作品视频
        panorama: "",//全景展示链接
        panoramaType:0,
        isElectricity:0,
        mobile: "",//电话
        email: "",//Email
        address: "",
      },
    };
  },
  computed: mapGetters(["userInfo", "isLogin"]),
  mounted() {
    this.activityId = this.$route.params.id;
    console.log("$route get activityId:", this.activityId);
    this.getInfo();

    console.log("$route get form:", this.form);

  },

  methods: {

    /**
     * 将 info 中与 form 键匹配的值赋值给 form
     * @param {Object} form - 目标对象
     * @param {Object} info - 源对象
     */
    assignFormValues(form, info) {
      Object.keys(form).forEach(key => {
        if (Object.prototype.hasOwnProperty.call(info, key)) {
          form[key] = info[key];
        }
      });
    },
    check(field) {
      const re = this.checkArr.includes(field);
      // console.log(field + "----" + re)
      return re;
    },
    onChange(a, b, c) {
      console.log("onChange:")
      console.log(a, b, c);
    },

    getInfo() {
      bannerAreaList({area: 1, num: 1})
          .then((res) => {
            this.bannerList = res.data;
          })
          .catch((err) => {
            console.log(err);
          });
      activityDetail(this.activityId, {isShow: 1, uid: this.userInfo.uid|0}).then(res => {
        console.log(res.data);
        this.activityInfo = res.data
        this.checkArr = res.data.signSetting == null ? [] : JSON.parse(res.data.signSetting)
        this.plateList = res.data.plateVos
        this.form.plateId=res.data.plateVos[0].id
        this.categoryList = res.data.categoryVos
        this.form.categoryId=res.data.categoryVos[0].id
        this.schoolList = res.data.schoolVos
        this.signConfig = res.data.configVos
      });
    },

    // 提交表单
    onSubmit() {
      // if (!this.isAgree) {
      //   this.$message.error("请同意并阅读《隐私协议》");
      //   return;
      // }
      let isValid = true;
      let firstErrorField = '';
      this.error = {
        activityId: '',
        plateId: '',
        categoryId: '',
        schoolId: "",
        compete:"",
        realName: "",
        avatar: '',
        sex: '',
        speciality: "",
        education: "",
        mentor: "",
        name: "",
        content: "",
        material: "",
        weight: "",
        worksSize: "",
        created: "",
        image: "",
        video: "",
        panorama: "",
        panoramaType:0,
        isElectricity:0,
        mobile: "",
        email: "",
        address: ""
      };
      if (this.check('plateId')&&!this.form.plateId) {
        this.error.plateId = "请选择参加的赛道类型";
        isValid = false
        // if (!firstErrorField) {
        //   firstErrorField = 'plateInput'
        // }
      }
      // if (this.check('compete')&&this.form.compete!='') {
      //   this.error.compete = "请选择参赛形式";
      //   isValid = false
      //
      // }
      if (this.check('realName')&&!this.form.realName) {
        this.error.realName = "请填写姓名"
        isValid = false
        if (!firstErrorField) {
          firstErrorField = 'realNameInput'
        }
      }
      if (this.check('avatar')&&!this.form.avatar) {
        this.$message.error("请上传作者照片")
        // this.error.avatar = "请上传作者头像"
        // isValid = false
        // if (!firstErrorField) {
        //   firstErrorField = 'avatarInput'
        // }
      }
      if (this.check('schoolId')&&!this.form.schoolId) {
        this.error.schoolId = "请选择机构（学校）"
        isValid = false
        if (!firstErrorField) {
          firstErrorField = 'schoolIdInput'
        }
      }
      if (this.check('mentor')&&!this.form.mentor) {
        this.error.mentor = "请填写指导老师"
        isValid = false
        if (!firstErrorField) {
          firstErrorField = 'mentorInput'
        }
      }
      if (this.check('name')&&!this.form.name) {
        this.error.name = "请填写作品名称"
        isValid = false
        if (!firstErrorField) {
          firstErrorField = 'nameInput'
        }
      }
      if (this.check('categoryId')&&!this.form.categoryId) {
        this.error.categoryId = "请选择所属类"
        isValid = false
        if (!firstErrorField) {
          firstErrorField = 'categoryInput'
        }
      }
      if (this.check('material')&&!this.form.material) {
        this.error.material = "请填写作品材料"
        isValid = false
        if (!firstErrorField) {
          firstErrorField = 'materialInput'
        }
      }
      if (this.check('worksSize')&&!this.form.worksSize) {
        this.error.worksSize = "请填写作品尺寸"
        isValid = false
        if (!firstErrorField) {
          firstErrorField = 'worksSizeInput'
        }
      }
      if (this.check('weight')&&!this.form.weight) {
        this.error.weight = "请填写作品重量"
        isValid = false
        if (!firstErrorField) {
          firstErrorField = 'weightInput'
        }
      }
      if (this.check('created')&&!this.form.created) {
        this.$message.error("请填写创作时间")
        // this.error.created = "请填写创作时间"
        // isValid = false
        // if (!firstErrorField) {
        //   firstErrorField = 'createdInput'
        // }
      }
      if (this.check('panorama')&&!this.form.panorama) {
        this.error.panorama = "请填写展陈要求"
        isValid = false
        if (!firstErrorField) {
          firstErrorField = 'panoramaInput'
        }
      }
      if (this.check('content')&&!this.form.content) {
        this.error.content = "请填写设计说明"
        isValid = false
        if (!firstErrorField) {
          firstErrorField = 'contentInput'
        }
      }
      if (this.check('image')&&!this.form.image) {
        this.$message.error("请上传作品图片")
        // this.error.image = "请上传作品图片"
        // isValid = false
        // if (!firstErrorField) {
        //   firstErrorField = 'imageInput'
        // }
      }
      // if (this.check('video')&&!this.form.video) {
      //   this.$message.error("请上传作品视频")
      //   // this.error.video = "请上传作品视频"
      //   // isValid = false
      //   // if (!firstErrorField) {
      //   //   firstErrorField = 'videoInput'
      //   // }
      // }
      if (this.check('email')&&!this.form.email) {
        this.error.email = "请填写收件邮箱"
        isValid = false
        if (!firstErrorField) {
          firstErrorField = 'emailInput'
        }
      }
      if (this.check('phone')&&!this.form.mobile) {
        this.error.mobile = "请填写联方式"
        isValid = false
        if (!firstErrorField) {
          firstErrorField = 'mobileInput'
        }
      }
      if (this.check('address')&&!this.form.address) {
        this.error.address = "请填写作品反寄地址"
        isValid = false
        if (!firstErrorField) {
          firstErrorField = 'addressInput'
        }
      }
      if (!isValid && firstErrorField) {
        console.log(firstErrorField)
        this.$refs[firstErrorField].focus()
        return
      }
      if (isValid) {
        if(this.isSubmitting) return;
        this.isSubmitting=true;
        this.submitForm();
      }


    },
    submitForm() {
      this.form.activityId = this.activityId;
      worksSignUp(this.form).then(res => {
        console.log("提交返回:", res.data);
        if (res.status == 200) {
          this.$message.success("报名成功！")
          setTimeout(() => {
            this.toUserCenter()
          }, 1000);
        }
        else {
          this.$message.error("报名失败！"+res.msg)
        }
        this.isSubmitting=false;
      })
    },
    toUserCenter(){
      this.$router.push({name: "UserCenter",query: {id:6}});
    },
    handleClcikAgree() {
      this.isAgree = !this.isAgree;
    },
    handleClickPrivacy() {
      // this.$router.push({name:"VoteWorksAgreement"})
      //新打开一个窗口，
      const targetRoute = this.$router.resolve({ name: "VoteWorksAgreement" });
      window.open(targetRoute.href, '_blank');
    },
  },
};
</script>
<style lang="scss">
.graduate-detail-sign {
  background: #f3f3f3;
  .competition-img {
    width: 100%;
    height: auto;      /* 高度自适应 */
    //min-width: 1024px; /* 最小宽度限制 */
    //max-width: 100%;   /* 最大不超过容器宽度 */
    object-fit: contain; /* 等比例显示 */
  }
  .course-img {
    width: 100%;
    height: auto;
  }
  .activityTitle {
    z-index: 10;
    margin-top: -100px;
    font-size: 40px;
    height: 80px;
    color: #E28947;
    text-align: center;
  }
  .sign-content {
    background: #ffffff;
    border: 1px solid #ddd;
    border-radius: 20px;
    margin: 0px auto;
    padding: 40px;
    width: 1280px;
    text-align: left;

    .collect-data {

      h3 {
        padding: 20px 0 10px 15px;
        margin: 0;
        font-size: 20px;
        color: #333;
        text-align: left;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          margin: 4px 0;
          left: 2px;
          width: 3px;
          height: 15px;
          background-color: #FF7606;
        }
      }

      .plate-info {
        text-align: left;

        .plate-options {
          margin: 10px 0 20px 15px;

          label {
            position: relative;
            margin-right: 20px;
            font-size: 16px;
            color: #333;
            cursor: pointer;
            display: inline-flex;
            align-items: center;

            /* 隐藏原生输入框 */
            .custom-radio {
              position: absolute;
              opacity: 0;
              width: 0;
              height: 0;
            }

            /* 自定义单选按钮样式 */
            .radio-label {
              position: relative;
              padding-left: 28px;

              &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 18px;
                height: 18px;
                border: 2px solid #ddd;
                border-radius: 50%;
                background: #fff;
                transition: all 0.2s;
              }

              &::after {
                content: '';
                position: absolute;
                left: 4px;
                top: 50%;
                transform: translateY(-50%) scale(0);
                width: 10px;
                height: 10px;
                background: #FF7606;
                border-radius: 50%;
                transition: all 0.2s;
              }
            }

            /* 选中状态 */
            .custom-radio:checked + .radio-label {
              &::before {
                border-color: #FF7606;
                background-color: rgba(247, 173, 109, 0.1);
              }
              &::after {
                transform: translateY(-50%) scale(1);
              }
            }

            /* 悬停状态 */
            &:hover .radio-label::before {
              border-color: #FF7606;
            }
          }

          .error {
            display: block;
            color: #ff4d4f;
            margin-top: 8px;
          }
        }
      }


      form {
        margin: 0 auto;
        //width: 1280px;
        width: 100%;
        //display: flex;
        //justify-content: space-between;

        p {
          margin-bottom: 10px;
          white-space: nowrap;
        }

        label {
          font-size: 15px;
          height: 41px;
          line-height: 41px;
          color: #333333;
          margin-right: 20px;
          float: left;
        }


        input, textarea {
          width: 100%;
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 5px;
          font-size: 16px;
          margin-bottom: 20px;
        }

        select {
          width: 100%;
          padding: 5px;
          border: 1px solid #ddd;
          border-radius: 5px;
          font-size: 16px;
          margin-bottom: 20px;
        }

        textarea {
          height: 100px;
          resize: vertical;
        }

        .person-info {
          text-align: left;
          p{
            #schoolId, #categoryId, #mentor, #material, #weight, #worksSize, #created, #content, #panorama, #video, #realName, #name, #mobile, #email, #address
            {
              width: 80%;
              height: 38px;

            }
            .ant-picker-suffix {
              display: none !important;
            }
            #image, #avatar {
              width: 120px;
              height: 120px;
              background: #f3f3f3;
            }
            i{
              margin: -15px 5px 0 0;
              width: 20px;
              color:#E96E26;
            }
          }
          .submit-button {
            margin: 20px 40%;
            width: 100px;
            height:40px;
            padding: 5px;
            background-color: #FF7606;
            color: white;
            border: none;
            border-radius: 5px;
            font-size: 16px;
            cursor: pointer;
            transition: background-color 0.3s ease;
          }
          .submit-button:hover {
            background-color: rgba(223, 118, 69, 0.58);
          }
        }
      }



      .error {
        color: red;
        font-size: 14px;
        margin-left: 10px;
      }
      .msg{
        margin-left: 90px;
        font-size: 12px;
      }
      #textarea {
        width: 814px;
        height: 220px;
        margin-bottom: 74px;
        resize: none;
      }

      input::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #d7d7d7;
      }

      input:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #d7d7d7;
      }

      input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #d7d7d7;
      }

      input:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #d7d7d7;
      }

    }

  }

  .agreement {
    margin: 10px 40px 10px -80px;
    color: #92989e;
    font-size: 13px;
    text-align: center;
    user-select: none;
    em {
      display: inline-block;
      width: 10px;
      height: 10px;
      border: 1px solid #aaa;
      &.isAgree {
        border-color: #da514e;
        background: url("~@/assets/img/login/tick.svg") no-repeat center center;
        background-size: 8px 8px;
      }
    }
    span {
      color: #447bdf;
      cursor: pointer;
    }
  }


}

</style>
